import React from 'react'

const Icon: React.FC<any> = ({ ...props }) => {
  return (
    <svg
      {...props}
      viewBox="0 0 21 22"
    >
      <path
        d="M14.0744 4.26611H3.32849C2.47853 4.26611 1.75 5.02934 1.75 5.98337V17.9406C1.75 18.8946 2.41782 19.6578 3.32849 19.6578H14.8636C15.7136 19.6578 16.4421 18.8946 16.4421 17.9406V7.70063 M10.067 14.188L7.09215 15.0784C6.72788 15.2056 6.42432 14.824 6.54575 14.506L7.3957 11.4531C7.45642 11.2623 7.51713 11.0715 7.69926 10.9443L16.0774 2.16716C16.5024 1.72195 17.1095 1.72195 17.5345 2.16716L18.9308 3.63001C19.3558 4.07523 19.3558 4.71125 18.9308 5.15646L10.5527 13.87C10.4313 14.0608 10.2491 14.1244 10.067 14.188Z"
      />
    </svg>
  )
}

export default Icon
